export default {
    generateContentModal: {
        title: 'Skapa innehåll',
        type: 'Typ',
        typePlaceholder: 'Välj typ',
        typeEmptyError: 'Vänligen välj typen',
        context: 'Sammanhang',
        contextPlaceholder: 'Välj sammanhang',
        contextEmptyError: 'Välj sammanhang, tack',
        contentTitle: 'Innehållsrubrik',
        contentTitlePlaceholder: 'Lägg till temat för ditt innehåll',
        contentTitleEmptyError: 'Ange titeln, tack',
        contentTitleInvalidError: 'Var vänlig ange en giltig titel',
        contentTitleNumberError: 'Var snäll och ange en titel som börjar med en bokstav',
        description: 'Ge en kort beskrivning av innehållet',
        descriptionPlaceholder: 'Lägg till en beskrivning av ditt innehåll i 2-3 rader',
        descriptionEmptyError: 'Vänligen ange beskrivning',
        descriptionInvalidError: 'Var god ange en giltig beskrivning',
        addKeywords: 'Lägg till nyckelord',
        addKeywordsEmptyError: 'Ange sökorden',
        writingTone: 'Skrivton',
        writingTonePlaceholder: 'Välj skrivton',
        writingToneEmptyError: 'Var god välj skrivton',
        numberOfVariations: 'Antal variationer',
        numberOfVariationsEmptyError: 'Vänligen välj antal variationer',
        numberOfVariationsInvalidError: 'Du kan generera högst 5 och minst 1 variation',
        generate: 'Generera',
        additionalOptions: 'Ytterligare alternativ',
        clear: 'Klar',
        writingToneOptions: {
            funny: 'Rolig',
            casual: 'vardaglig',
            excited: 'Spänd',
            professional: 'Professionell',
            witty: 'Vitsig',
            sarcastic: 'Sarkastisk',
            feminine: 'Feminin',
            masculine: 'maskulin',
            bold: 'djärv, modig, vågad, fet',
            dramatic: 'Dramatisk',
            grumpy: 'Surmulet',
            secretive: 'Hemlighetsfull',
            respectful: 'Respektfull',
            persuasive: 'Övertygande',
        },
        contextOptions: {
            promotional: 'Reklam-',
            introduction: 'Introduktion',
            couponDiscount: 'Kupong/Rabatt',
            recurringNewsletter: 'Återkommande nyhetsbrev',
            testimonial: 'Referens eller vittnesmål',
            coldOutreach: 'Kall uppsökande verksamhet',
            contentGiveaway: 'Innehåll/Utlottning',
            other: 'Andra',
        },
        typeOptions: {
            outline: 'Kontur',
            introduction: 'Introduktion',
            section: 'Avsnitt',
        },
        customLengthOfContentPlaceholder: 'Número de palabras (máx. 900)',
        lengthOfContentPlaceholder: 'Seleccione la longitud del contenido',
        lengthOfContent: 'Longitud del contenido',
        customLengthOfContent: 'Anpassad längd',
        smallContent: 'Pequeño',
        mediumContent: 'Medel',
        largeContent: 'Stor',
        customContentLength: 'Longitud personalizada (50 - 900 palabras)',
        lengthOfContentError: 'Vänligen välj längden på innehållet',
        customLengthError: 'Valor incorrecto',
        lengthOfContentTooltip: 'Ange längden på innehållet som kommer att genereras baserat på förklaringen av ledtexterna',
    },
};
